'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    const register = async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
        });

        // Prompt waiting SW to activate immediately
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      } catch (err) {
        console.warn('[IlmHub] Service worker registration failed:', err);
      }
    };

    register();

    // Listen for sync-complete messages from the SW
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SYNC_COMPLETE') {
        const count = event.data.synced ?? 0;
        if (count > 0) {
          console.info(`[IlmHub] Background sync complete — ${count} request(s) replayed.`);
        }
      }
    };
    navigator.serviceWorker.addEventListener('message', handleMessage);

    // When coming back online, trigger background sync
    const handleOnline = async () => {
      try {
        const reg = await navigator.serviceWorker.ready;
        if ('sync' in reg) {
          await (reg as ServiceWorkerRegistration & { sync: { register(tag: string): Promise<void> } }).sync.register('ilmhub-sync');
        } else {
          // Fallback: ask SW to flush queue directly
          reg.active?.postMessage({ type: 'FLUSH_QUEUE' });
        }
      } catch (e) {
        console.warn('[IlmHub] Sync registration failed:', e);
      }
    };

    window.addEventListener('online', handleOnline);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return null;
}
